import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useNavigate,
  useLocation,
  useParams,
} from "react-router-dom";
import {
  fetchUserDetails,
  getCheckoutClientInfo,
  removeCheckoutClientInfo,
  switchUserRole,
} from "../../services/authService";
import "./Nav.css";
import { useUser } from "../../context/UserContext";
import { useConfig } from "../../context/AppConfigContext";
import { JS_CSS_IMG_VERSION } from "../../config/apiConfig";
import SearchBoxV2 from "./SearchV2";
import UserDropDown from "./userDropDown/UserDropDown";
import GenericOverviewSideCard from "../Frontend/genericComponents/GenericOverviewSideCard";
import MemoryContainerSC from "./memoryComps/MemoryContainerSC";
import { useDispatch } from "react-redux";
import { listGlobalMemRequest } from "../../store/features/actions/memory/globalMemoryActions";
import * as FeatherIcon from "react-feather";

export default function NavTop() {
  const { user, setUser, setUserRole, handleLogout } = useUser();
  const [showMoreModal, setShowMoreModal] = useState(false);
  const { appConfig } = useConfig();
  const [currentRole, setCurrentRole] = useState(user?.role);
  const [currentRoleKey, setCurrentRoleKey] = useState(user?.role_key);
  const user_roles = !user?.roles ? [] : user?.roles;
  const user_roles_keys = !appConfig?.user_roles_api
    ? []
    : appConfig?.user_roles_api;
  const [filteredRoles, setFilteredRoles] = useState([]);
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState("");
  const dispatch = useDispatch();

  const { clientName, accountName } = useParams();
  const [nav_urls, setNavUrls] = useState({
    dashboard_url: "/dashboard",
    companies_url: "/clients_accounts",
    watchboard_url: "/watchboard",
    benchmarks_url: "/benchmarks",
    ai_assistannt_url: "/ai_assistant",
  });

  const navigate = useNavigate();

  const getRoleKeyByRole = (role) => {
    let user_role_key = "";
    for (const role_key in user_roles_keys) {
      if (parseInt(user_roles_keys[role_key]) === parseInt(role)) {
        user_role_key = role_key;
        break;
      }
    }
    return user_role_key;
  };

  useEffect(() => {
    if (appConfig) {
      let current_role = user?.role;
      setCurrentRole(current_role);

      let user_role_key = getRoleKeyByRole(current_role);
      setCurrentRoleKey(user_role_key);

      const configUserRoles = appConfig.user_roles;
      const updatedFilteredRoles = Object.keys(configUserRoles).filter(
        (role) =>
          user_roles.includes(parseInt(role)) &&
          parseInt(role) !== parseInt(currentRole)
      );
      setFilteredRoles(updatedFilteredRoles);
    }
  }, [appConfig, currentRole, user_roles, currentRoleKey]);

  useEffect(() => {
    // Check URL path and set the expanded state
    if (location.pathname.indexOf("dashboard") !== -1) {
      // setExpandedMenu('companies');
      setActiveMenu("clients_dashboard");
    } else if (
      location.pathname.startsWith("/clients_accounts") ||
      location.pathname.startsWith("/account_details")
    ) {
      // setExpandedMenu('companies');
      setActiveMenu("clients_accounts");
    } else if (location.pathname.indexOf("ai_assistant") !== -1) {
      // setExpandedMenu('companies');
      setActiveMenu("ai_assistant");
    } else if (location.pathname.indexOf("/watchboard") !== -1) {
      // setExpandedMenu('companies');
      setActiveMenu("watchboard");
    } else if (location.pathname.indexOf("/benchmarks") !== -1) {
      // setExpandedMenu('companies');
      setActiveMenu("benchmarks");
    } else {
      setActiveMenu("");
    }

    /*
    setNavUrls] = useState({
      'dashboard_url' : '/dashboard',
      'companies_url' : '/clients_accounts',
      'ai_assistannt_url' : '/ai_assistant'
    })
    */

    const checkoutClientClientInfo = getCheckoutClientInfo();

    const client_id = checkoutClientClientInfo?.checkoutClientId || "";
    const client_name = checkoutClientClientInfo?.checkoutClientName || "";

    const url_obj =
      client_id && client_name
        ? {
          dashboard_url: "/dashboard",
          watchboard_url: "watchboard",
          companies_url: "/clients_accounts/" + client_id + "/" + client_name,
          benchmarks_url: "/benchmarks/" + client_id + "/" + client_name,
          ai_assistannt_url: "/ai_assistant",
        }
        : {
          dashboard_url: "/dashboard",
          companies_url: "/clients_accounts",
          ai_assistannt_url: "/ai_assistant",
        };

    setNavUrls(url_obj);
  }, [location.pathname]);

  if (!appConfig) {
    return <></>;
  }

  const switchUser = async (role) => {
    removeCheckoutClientInfo();
    const { access_token, refresh_token } = await switchUserRole(
      parseInt(role)
    );
    if (access_token) {
      setCurrentRole(role);
      let user_role_key = getRoleKeyByRole(role);
      //setCurrentRoleKey(user_role_key);
      // setUserRole(role, user_role_key);
      // window.location.replace('/users'); // This will navigate to the /users page

      const userInfo = await fetchUserDetails();

      setUser(userInfo);

      // if (user_role_key === "SALES_DEMO") {
      //   navigate("/sales_accounts");
      // } else if (
      //   user_role_key === "CLIENT" ||
      //   user_role_key === "CLIENT_EMPLOYEE"
      // ) {
      //   user.is_onboarded = 1;
      //   if (user?.is_onboarded == null || user?.is_onboarded === 0) {
      //     navigate("/user_profile/profile");
      //   } else {
      //     navigate("/watchboard");
      //   }
      // } else if (user_role_key === "ANALYST") {
      //   navigate("/demo_requests");
      // } else {
      //   navigate("/users/user_dashboard");
      // }
    }
  };

  const configUserRoles = appConfig.user_roles;

  if (location.pathname.startsWith("/customers")) {
    return null;
  }

  return (
    <>
      <nav
        className={`navbar navtop navbar-expand-lg navbar-default ${currentRoleKey !== "CLIENT" &&
            currentRoleKey !== "CLIENT_EMPLOYEE" &&
            currentRoleKey !== "SALES_DEMO"
            ? "admin_nav"
            : ""
          } `}
      >
        {/* <Link className="navbar-brand" to={(currentRoleKey === 'CLIENT' || currentRoleKey === 'CLIENT_EMPLOYEE') ? '/dashboard' : ( currentRoleKey === 'SALES_DEMO' ? '/sales_accounts' : '/users/user_dashboard' )}>
          <img src={`/img/mnm_logo_white.png?version=${JS_CSS_IMG_VERSION}`} alt="logo" width="100" className="" />
        </Link> */}

        <span className="navbar-brand">
          {/* <img src={`/img/mnm_logo_white.png?version=${JS_CSS_IMG_VERSION}`} alt="logo" width="140" className="" /> */}
          {/* <img src={`/img/mnm_logo.png?version=${JS_CSS_IMG_VERSION}`} alt="logo" width="50" className="" /> */}
        </span>

        {/* <div className='ml-4'>   {location.pathname.indexOf('sales_accounts') === -1 && <SearchBoxV2  /> }</div> */}

        <div className="container-fluid">
          <ul className="navbar-nav ms-auto pl-lg-4 right_nav_menu">
            {accountName && clientName && (
              <button
                className="memory-btn-parent"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowMoreModal(true);
                  dispatch(
                    listGlobalMemRequest({
                      userId: user?.id,
                      memoryType: "global",
                    })
                  );
                }}
              >
                Memory
              </button>
            )}
            {accountName && clientName && (
              <div className="vertical-divider-parental" />
            )}

            {/* <div style={{
        // width: "70px",
        height: "20px",
      }}>
        <FeatherIcon.Bookmark className='bookmark-icon' style={{marginRight: "20px"}} />

        <FeatherIcon.Bell className='bookmark-icon' />
      </div>

      <div className='vertical-divider-parental'/> */}

            {/* <UserDropDown
              user={user}
              currentRoleKey={currentRoleKey}
              filteredRoles={filteredRoles}
              configUserRoles={configUserRoles}
              switchUser={switchUser}
              handleLogout={handleLogout}
            /> */}
          </ul>
        </div>
      </nav>

      <GenericOverviewSideCard
        showMoreModal={showMoreModal}
        setShowMoreModal={setShowMoreModal}
        titleForSideCard={
          <div className="mem-sc-titl-cont">
            <img
              className="back-btn-img"
              src="/img/backArrow.png"
              onClick={() => setShowMoreModal(false)}
            />{" "}
            <span className="span_memory">Memory</span>
          </div>
        }
        comp={<MemoryContainerSC memoryType="global" />}
        minWidthForDrawer="30%"
        disableXbtn
      />
    </>
  );
}
